import { Image } from "@/components/display";
import { extractMessageFromError } from "@/shared/notification";
import { Articulo } from "@/shared/types/articulo";
import { Grid2 as Grid, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

interface PreviewArticuloProps {
    articulo?: Articulo | null,
    error?: Error,
    notFoundText?: string
}

export default function PreviewArticulo({
    articulo,
    error,
    notFoundText = "No se ha encontrado ningún artículo."
}: PreviewArticuloProps) {
    if (!articulo) return <NotFound notFoundText={notFoundText} />
    else if (error) return <Error error={error} />
    else return <ArticuloRender articulo={articulo} />
}

function NotFound({ notFoundText }: { notFoundText: string }) {
    return <Stack gap={2} flex={1} padding={2}>
        <Typography variant="body1" color="text.secondary">{notFoundText}</Typography>
    </Stack>
}

function Error({ error }: { error: Error }) {
    return <Stack gap={2} flex={1} padding={2}>
        <Typography variant="body1" color="error.light">{extractMessageFromError(error)}</Typography>
    </Stack>
}

function ArticuloRender({ articulo }: { articulo?: Articulo }) {
    return <Stack direction={"row"} gap={3} alignItems={"start"} justifyContent={"center"} flexWrap={"wrap"}>
        <Image width={{ xs: "150px", md: "150px" }} src={articulo?.imagen} />
        <Stack gap={0} flex={1}>
            <Stack gap={0}>
                <Typography variant="h5">{articulo?.nombre}</Typography>
                <Typography variant="subtitle2" color="text.secondary">{articulo?.rubroNombre}</Typography>
            </Stack>
            <Grid container columns={1}>
                <Grid size={1}> <AttributeValuePair label="Código: " value={articulo?.codigo} /> </Grid>
                <Grid size={1}> <AttributeValuePair label="N° Item: " value={articulo?.numeroItem} /> </Grid>
                <Grid size={1}> <AttributeValuePair label="Cantidad: " value={articulo?.cantidad} /> </Grid>
            </Grid>
        </Stack>
    </Stack>
}

function AttributeValuePair({ label, value }: { label: ReactNode, value: ReactNode }) {
    return <Stack direction={"row"} alignItems={"center"} gap={2}>
        <Typography variant="subtitle1">{label}</Typography>
        <Typography variant="body1">{!value && value !== 0 ? "---" : value}</Typography>
    </Stack>
}
